(function () {
    document.querySelectorAll('[data-cotis-product]').forEach(function (root) {
      if (root.dataset.cpReady === 'true') return;
      root.dataset.cpReady = 'true';

      var slides = root.querySelectorAll('[data-cp-slide]');
      root.querySelectorAll('[data-cp-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = thumb.getAttribute('data-cp-thumb');
          slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-cp-slide') === i); });
          root.querySelectorAll('[data-cp-thumb]').forEach(function (t) {
            var active = t === thumb;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      });

      var qtyInput = root.querySelector('.cp-qty-input');
      root.querySelectorAll('[data-cp-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-cp-qty'), 10);
          qtyInput.value = next < 1 ? 1 : next;
        });
      });

      var dataEl = root.querySelector('[data-cp-variants]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-cp-variant-id]');
      var priceEl = root.querySelector('[data-cp-price]');
      var compareEl = root.querySelector('[data-cp-compare]');
      var atc = root.querySelector('[data-cp-atc]');
      var atcText = root.querySelector('[data-cp-atc-text]');
      var atcPrice = root.querySelector('[data-cp-atc-price]');
      var stickyPrice = root.querySelector('[data-cp-sticky-price]');
      var stockText = root.querySelector('[data-cp-stock-text]');
      var soldOutLabel = 'Sold out';
      var addLabel = atcText ? atcText.textContent.trim() : 'Add to cart';
      var inStockLabel = stockText ? stockText.textContent.trim() : '';

      function money(cents) {
        if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      function update() {
        var opts = Array.prototype.map.call(root.querySelectorAll('.cp-option'), function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        if (!opts.length) return;
        var match = variants.filter(function (v) {
          return opts.every(function (o, i) { return v.options[i] === o; });
        })[0];
        if (!match) return;

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (atcPrice) atcPrice.textContent = money(match.price);
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (atc) atc.disabled = !match.available;
        if (atcText) atcText.textContent = match.available ? addLabel : soldOutLabel;
        if (stockText) stockText.textContent = match.available ? inStockLabel : soldOutLabel;

        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('[data-cp-option-value]').forEach(function (input) {
        input.addEventListener('change', update);
      });

      var sticky = root.querySelector('[data-cp-sticky]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var stickyAdd = root.querySelector('[data-cp-sticky-add]');
      if (stickyAdd && form) {
        stickyAdd.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
        });
      }
      if (sticky && atc && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { sticky.hidden = entry.isIntersecting; });
        }, { rootMargin: '0px 0px -40px 0px' });
        io.observe(atc);
      }
    });
  })();
